import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ClassNames } from '@emotion/react';
import { lengths, fonts } from 'decap-cms-ui-default';
import { createEditor } from 'slate';
import { Editable, ReactEditor, Slate, withReact } from 'slate-react';
import { withHistory } from 'slate-history';
import { editorStyleVars, EditorControlBar } from '../styles';
import Toolbar from './Toolbar';
import defaultEmptyBlock from './plugins/blocks/defaultEmptyBlock';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
function rawEditorStyles({
  minimal
}) {
  return `
  position: relative;
  overflow: hidden;
  overflow-x: auto;
  min-height: ${minimal ? 'auto' : lengths.richTextEditorMinHeight};
  font-family: ${fonts.mono};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: 0;
  margin-top: -${editorStyleVars.stickyDistanceBottom};
`;
}
const RawEditorContainer = /*#__PURE__*/_styled("div", {
  target: "e12tj7710",
  label: "RawEditorContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9NYXJrZG93bkNvbnRyb2wvUmF3RWRpdG9yLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRCcUMiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL01hcmtkb3duQ29udHJvbC9SYXdFZGl0b3IuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VFZmZlY3QsIHVzZU1lbW8sIHVzZVN0YXRlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBJbW11dGFibGVQcm9wVHlwZXMgZnJvbSAncmVhY3QtaW1tdXRhYmxlLXByb3B0eXBlcyc7XG5pbXBvcnQgeyBDbGFzc05hbWVzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgbGVuZ3RocywgZm9udHMgfSBmcm9tICdkZWNhcC1jbXMtdWktZGVmYXVsdCc7XG5pbXBvcnQgeyBjcmVhdGVFZGl0b3IgfSBmcm9tICdzbGF0ZSc7XG5pbXBvcnQgeyBFZGl0YWJsZSwgUmVhY3RFZGl0b3IsIFNsYXRlLCB3aXRoUmVhY3QgfSBmcm9tICdzbGF0ZS1yZWFjdCc7XG5pbXBvcnQgeyB3aXRoSGlzdG9yeSB9IGZyb20gJ3NsYXRlLWhpc3RvcnknO1xuXG5pbXBvcnQgeyBlZGl0b3JTdHlsZVZhcnMsIEVkaXRvckNvbnRyb2xCYXIgfSBmcm9tICcuLi9zdHlsZXMnO1xuaW1wb3J0IFRvb2xiYXIgZnJvbSAnLi9Ub29sYmFyJztcbmltcG9ydCBkZWZhdWx0RW1wdHlCbG9jayBmcm9tICcuL3BsdWdpbnMvYmxvY2tzL2RlZmF1bHRFbXB0eUJsb2NrJztcblxuZnVuY3Rpb24gcmF3RWRpdG9yU3R5bGVzKHsgbWluaW1hbCB9KSB7XG4gIHJldHVybiBgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgb3ZlcmZsb3cteDogYXV0bztcbiAgbWluLWhlaWdodDogJHttaW5pbWFsID8gJ2F1dG8nIDogbGVuZ3Rocy5yaWNoVGV4dEVkaXRvck1pbkhlaWdodH07XG4gIGZvbnQtZmFtaWx5OiAke2ZvbnRzLm1vbm99O1xuICBib3JkZXItdG9wLWxlZnQtcmFkaXVzOiAwO1xuICBib3JkZXItdG9wLXJpZ2h0LXJhZGl1czogMDtcbiAgYm9yZGVyLXRvcDogMDtcbiAgbWFyZ2luLXRvcDogLSR7ZWRpdG9yU3R5bGVWYXJzLnN0aWNreURpc3RhbmNlQm90dG9tfTtcbmA7XG59XG5cbmNvbnN0IFJhd0VkaXRvckNvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbmA7XG5mdW5jdGlvbiBSYXdFZGl0b3IocHJvcHMpIHtcbiAgY29uc3QgeyBjbGFzc05hbWUsIGZpZWxkLCBpc1Nob3dNb2RlVG9nZ2xlLCB0LCBvbkNoYW5nZSB9ID0gcHJvcHM7XG5cbiAgY29uc3QgZWRpdG9yID0gdXNlTWVtbygoKSA9PiB3aXRoUmVhY3Qod2l0aEhpc3RvcnkoY3JlYXRlRWRpdG9yKCkpKSwgW10pO1xuXG4gIGNvbnN0IFt2YWx1ZSwgc2V0VmFsdWVdID0gdXNlU3RhdGUoXG4gICAgcHJvcHMudmFsdWVcbiAgICAgID8gcHJvcHMudmFsdWUuc3BsaXQoJ1xcbicpLm1hcChsaW5lID0+IGRlZmF1bHRFbXB0eUJsb2NrKGxpbmUpKVxuICAgICAgOiBbZGVmYXVsdEVtcHR5QmxvY2soKV0sXG4gICk7XG5cbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBpZiAocHJvcHMucGVuZGluZ0ZvY3VzKSB7XG4gICAgICBSZWFjdEVkaXRvci5mb2N1cyhlZGl0b3IpO1xuICAgICAgcHJvcHMucGVuZGluZ0ZvY3VzKCk7XG4gICAgfVxuICB9LCBbcHJvcHMucGVuZGluZ0ZvY3VzXSk7XG5cbiAgZnVuY3Rpb24gaGFuZGxlVG9nZ2xlTW9kZSgpIHtcbiAgICBwcm9wcy5vbk1vZGUoJ3JpY2hfdGV4dCcpO1xuICB9XG5cbiAgZnVuY3Rpb24gaGFuZGxlQ2hhbmdlKHZhbHVlKSB7XG4gICAgb25DaGFuZ2UodmFsdWUubWFwKGxpbmUgPT4gbGluZS5jaGlsZHJlblswXS50ZXh0KS5qb2luKCdcXG4nKSk7XG4gICAgc2V0VmFsdWUodmFsdWUpO1xuICB9XG5cbiAgcmV0dXJuIChcbiAgICA8U2xhdGUgZWRpdG9yPXtlZGl0b3J9IHZhbHVlPXt2YWx1ZX0gaW5pdGlhbFZhbHVlPXt2YWx1ZX0gb25DaGFuZ2U9e2hhbmRsZUNoYW5nZX0+XG4gICAgICA8UmF3RWRpdG9yQ29udGFpbmVyPlxuICAgICAgICA8RWRpdG9yQ29udHJvbEJhcj5cbiAgICAgICAgICA8VG9vbGJhclxuICAgICAgICAgICAgb25Ub2dnbGVNb2RlPXtoYW5kbGVUb2dnbGVNb2RlfVxuICAgICAgICAgICAgYnV0dG9ucz17ZmllbGQuZ2V0KCdidXR0b25zJyl9XG4gICAgICAgICAgICBkaXNhYmxlZFxuICAgICAgICAgICAgcmF3TW9kZVxuICAgICAgICAgICAgaXNTaG93TW9kZVRvZ2dsZT17aXNTaG93TW9kZVRvZ2dsZX1cbiAgICAgICAgICAgIHQ9e3R9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9FZGl0b3JDb250cm9sQmFyPlxuICAgICAgICA8Q2xhc3NOYW1lcz5cbiAgICAgICAgICB7KHsgY3NzLCBjeCB9KSA9PiAoXG4gICAgICAgICAgICA8RWRpdGFibGVcbiAgICAgICAgICAgICAgY2xhc3NOYW1lPXtjeChcbiAgICAgICAgICAgICAgICBjbGFzc05hbWUsXG4gICAgICAgICAgICAgICAgY3NzYFxuICAgICAgICAgICAgICAgICAgJHtyYXdFZGl0b3JTdHlsZXMoeyBtaW5pbWFsOiBmaWVsZC5nZXQoJ21pbmltYWwnKSB9KX1cbiAgICAgICAgICAgICAgICBgLFxuICAgICAgICAgICAgICApfVxuICAgICAgICAgICAgICB2YWx1ZT17dmFsdWV9XG4gICAgICAgICAgICAgIG9uQ2hhbmdlPXtoYW5kbGVDaGFuZ2V9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICl9XG4gICAgICAgIDwvQ2xhc3NOYW1lcz5cbiAgICAgIDwvUmF3RWRpdG9yQ29udGFpbmVyPlxuICAgIDwvU2xhdGU+XG4gICk7XG59XG5cblJhd0VkaXRvci5wcm9wVHlwZXMgPSB7XG4gIG9uQ2hhbmdlOiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICBvbk1vZGU6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB2YWx1ZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgZmllbGQ6IEltbXV0YWJsZVByb3BUeXBlcy5tYXAuaXNSZXF1aXJlZCxcbiAgaXNTaG93TW9kZVRvZ2dsZTogUHJvcFR5cGVzLmJvb2wuaXNSZXF1aXJlZCxcbiAgdDogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFJhd0VkaXRvcjtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function RawEditor(props) {
  const {
    className,
    field,
    isShowModeToggle,
    t,
    onChange
  } = props;
  const editor = useMemo(() => withReact(withHistory(createEditor())), []);
  const [value, setValue] = useState(props.value ? props.value.split('\n').map(line => defaultEmptyBlock(line)) : [defaultEmptyBlock()]);
  useEffect(() => {
    if (props.pendingFocus) {
      ReactEditor.focus(editor);
      props.pendingFocus();
    }
  }, [props.pendingFocus]);
  function handleToggleMode() {
    props.onMode('rich_text');
  }
  function handleChange(value) {
    onChange(value.map(line => line.children[0].text).join('\n'));
    setValue(value);
  }
  return _jsx(Slate, {
    editor: editor,
    value: value,
    initialValue: value,
    onChange: handleChange,
    children: _jsxs(RawEditorContainer, {
      children: [_jsx(EditorControlBar, {
        children: _jsx(Toolbar, {
          onToggleMode: handleToggleMode,
          buttons: field.get('buttons'),
          disabled: true,
          rawMode: true,
          isShowModeToggle: isShowModeToggle,
          t: t
        })
      }), _jsx(ClassNames, {
        children: ({
          css,
          cx
        }) => _jsx(Editable, {
          className: cx(className, css`
                  ${rawEditorStyles({
            minimal: field.get('minimal')
          })}
                `),
          value: value,
          onChange: handleChange
        })
      })]
    })
  });
}
RawEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  onMode: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  value: PropTypes.string,
  field: ImmutablePropTypes.map.isRequired,
  isShowModeToggle: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};
export default RawEditor;